import React from 'react';
import { useTranslation } from 'react-i18next';

// store_type is the store's supply method. The backend sends the enum
// (ONLY_DELIVERY) in most places but the label ("Only Delivery") in some,
// so both map to the store registration translations.
const SUPPLY_METHOD_LABEL_KEYS: Record<string, string> = {
  ONLY_DELIVERY: 'storeRegister.onlyDelivery',
  'Only Delivery': 'storeRegister.onlyDelivery',
  ONLY_PICK_UP: 'storeRegister.onlyPickup',
  'Only Pick Up': 'storeRegister.onlyPickup',
  PICK_AND_DELIVERY: 'storeRegister.pickAndDelivery',
  'Pick and Delivery': 'storeRegister.pickAndDelivery',
};

/** Translation key for a store_type value, or undefined if it's unknown */
export const getSupplyMethodLabelKey = (
  storeType?: string | null
): string | undefined =>
  storeType ? SUPPLY_METHOD_LABEL_KEYS[storeType] : undefined;

interface StoreBannerFallbackProps {
  storeName?: string | null;
  storeType?: string | null;
}

/**
 * Text drawn over the brand artwork when a store has no banners.
 * Used as StoreCarousel's `fallbackContent` on both the public store page and
 * the seller dashboard, so sellers preview exactly what shoppers see.
 */
export default function StoreBannerFallback({
  storeName,
  storeType,
}: StoreBannerFallbackProps) {
  const { t } = useTranslation();
  const labelKey = getSupplyMethodLabelKey(storeType);
  const supplyLabel = labelKey ? t(labelKey) : '';

  return (
    <div className="px-4 px-md-5" style={{ maxWidth: 680 }}>
      <span className="badge rounded-pill text-uppercase bg-success-subtle text-success-emphasis mb-2 d-none d-sm-inline-block">
        Welcome to
      </span>
      <h2 className="fs-2 fw-bold text-dark lh-sm mb-1 mb-md-2">
        {storeName}
      </h2>
      <p className="text-body-secondary mb-0 d-none d-md-block">
        {supplyLabel && `${supplyLabel} · `}
        Browse the products below and add your favourites to the cart.
      </p>
    </div>
  );
}
